import axios from "axios";

/**
 * The server's own refusal sentence, when it has one.
 *
 * Endpoints on this product refuse for reasons a consumer can act on — "ya
 * subiste un comprobante", "esta solicitud ya está pagada" — and that sentence
 * is the only actionable part of the response. A generic "intentá de nuevo"
 * over the top of it invites them to retry something that can never succeed.
 *
 * Returns null rather than a fallback so the caller supplies its own TRANSLATED
 * default: this helper has no i18n context and should not invent copy.
 */
export function serverMessage(error: unknown): string | null {
  if (!axios.isAxiosError(error)) return null;
  const message = (error.response?.data as { message?: unknown } | undefined)?.message;
  if (typeof message === "string" && message.trim() !== "") return message;
  // Nest's ValidationPipe answers with an array of constraint strings.
  if (Array.isArray(message) && message.every((m) => typeof m === "string")) {
    return message.join(", ");
  }
  return null;
}
